<div class="row align-items-center justify-content-center">
  <div class="col col-xl-6 col-lg-8">
    <app-cards-basic title="Set New Password"
                     description="Setze dein neues Passwort"
                     [loading]="isLoading">
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Neues Passwort</mat-label>
          <input matInput
                 formControlName="password"
                 type="password"
                 required>
          @if (resetForm.get('password')?.invalid && resetForm.get('password')?.touched) {
            <mat-error>
              Bitte geben Sie ein gültiges Passwort ein.
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Passwort bestätigen</mat-label>
          <input matInput
                 formControlName="confirmPassword"
                 type="password"
                 required>
          @if (resetForm.get('confirmPassword')?.invalid && resetForm.get('confirmPassword')?.touched) {
            <mat-error>
              Bitte bestätigen Sie Ihr Passwort.
            </mat-error>
          }
        </mat-form-field>

        <button mat-flat-button
                color="primary"
                type="submit"
                class="bp-button bp-button--large w-100"
                [disabled]="resetForm.invalid || isLoading">
          Passwort festlegen
        </button>
      </form>


  @if(successMessage){
    <p>{{ successMessage }}</p>
  }
  @if(errorMessage){
    <p class="error">{{ errorMessage }}</p>
  }

    </app-cards-basic>
  </div>
</div>
